import { PRIVATE_BASE_URL } from 'configs'

export const getApiUrlTemplateFunc = (templatePath: string) => {
  return (path = '', params = {}) => {
    const searchParamsPresent = Object.keys(params).length !== 0
    const pathPresent = path !== ''
    const templatePathPresent = templatePath.trim() !== ''

    let baseUrl = PRIVATE_BASE_URL
    if (templatePathPresent) {
      baseUrl += `/${templatePath}`
    }
    if (pathPresent) {
      baseUrl += `/${path}`
    }

    if (searchParamsPresent) {
      const searchParams = new URLSearchParams(params)
      return `${baseUrl}?${searchParams}`
    }

    return baseUrl
  }
}
